import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faTachometerAlt,
  faFileDownload,
  faUser,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

const DashboardSideMenu = () => {
  const [pName, setPName] = useState("");
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    checkActive();
  }, []);

  const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    //console.log('location',location);
    setPName(pathname);
  };

  const menuHideShow = () => {
    let menubar = document.getElementById("mobile-dashboard-menu");
    menubar.classList.remove("layout-menu-expanded");
  };

  const isGroupActive = (routeChecks) =>
    routeChecks.some((check) => pName.includes(check));

  const isGroupOpen = (key, routeChecks) =>
    openGroups[key] !== undefined ? openGroups[key] : isGroupActive(routeChecks);

  const toggleGroup = (key, routeChecks) => {
    setOpenGroups((prev) => ({
      ...prev,
      [key]: !isGroupOpen(key, routeChecks),
    }));
  };

  const reportingRoutes = [
    "/dashboard/summary-report",
    "/dashboard/date-wise-summary-report",
    "/dashboard/details-report",
  ];
  const downloadRoutes = ["/dashboard/download-report"];
  const profileRoutes = ["/dashboard/profile", "/dashboard/balance-history"];

  useEffect(() => {
    const groups = [
      { key: "reporting", routes: reportingRoutes },
      { key: "download", routes: downloadRoutes },
      { key: "profile", routes: profileRoutes },
    ];
    const activeGroup = groups.find((g) =>
      g.routes.some((r) => pName.includes(r))
    );
    if (activeGroup) {
      setOpenGroups((prev) =>
        prev[activeGroup.key] ? prev : { ...prev, [activeGroup.key]: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pName]);

  return (
    <div id="mobile-dashboard-menu">
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
      >
        <div className="app-brand demo">
          <a href="/dashboard" className="app-brand-link">
            <span className="app-brand-text demo menu-text fw-bolder ms-2">
              SMPP-SMS
            </span>
          </a>
          <button className="menu-btn" onClick={menuHideShow}>
            {" "}
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>

        <div className="menu-inner-shadow"></div>

        <ul className="menu-inner py-1">
          <li
            className={
              pName === "/dashboard" ? "menu-item active" : "menu-item"
            }
          >
            <NavLink to="/dashboard" className="menu-link">
              <FontAwesomeIcon icon={faHome} className="mr-2" />
              <div> Dashboard</div>
            </NavLink>
          </li>

          {/* Reporting */}
          <li
            className={
              isGroupOpen("reporting", reportingRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("reporting", reportingRoutes)}
            >
              <FontAwesomeIcon icon={faTachometerAlt} className="menu-icon tf-icons mr-2" />
              <div>Reporting</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName === "/dashboard/summary-report"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/dashboard/summary-report" className="menu-link">
                  <div>Sender ID Wise Report</div>
                </Link>
              </li>

              <li
                className={
                  pName === "/dashboard/date-wise-summary-report"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link
                  to="/dashboard/date-wise-summary-report"
                  className="menu-link"
                >
                  <div>Date Wise Report</div>
                </Link>
              </li>

              <li
                className={
                  pName === "/dashboard/details-report"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/dashboard/details-report" className="menu-link">
                  <div>Detailed Report</div>
                </Link>
              </li>
            </ul>
          </li>

          {/* Download */}
          <li
            className={
              isGroupOpen("download", downloadRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("download", downloadRoutes)}
            >
              <FontAwesomeIcon icon={faFileDownload} className="menu-icon tf-icons mr-2" />
              <div data-i18n="Tables">Download</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName === "/dashboard/download-report"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/dashboard/download-report" className="menu-link">
                  <div data-i18n="Tables">Download Report</div>
                </Link>
              </li>
            </ul>
          </li>

          {/* My Profile */}
          <li
            className={
              isGroupOpen("profile", profileRoutes)
                ? "menu-item open"
                : "menu-item"
            }
          >
            <a
              href="javascript:void(0);"
              className="menu-link menu-toggle"
              onClick={() => toggleGroup("profile", profileRoutes)}
            >
              <FontAwesomeIcon icon={faUser} className="menu-icon tf-icons mr-2" />
              <div data-i18n="Support">My Profile</div>
            </a>
            <ul className="menu-sub">
              <li
                className={
                  pName === "/dashboard/profile"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/dashboard/profile" className="menu-link">
                  <div data-i18n="Support">Profile</div>
                </Link>
              </li>

              <li
                className={
                  pName === "/dashboard/balance-history"
                    ? "menu-item active"
                    : "menu-item"
                }
              >
                <Link to="/dashboard/balance-history" className="menu-link">
                  <div data-i18n="Support">Balance History</div>
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default DashboardSideMenu;
